export default {
  active: 'Active',
  toCancele: 'Termination period',
  toActive: 'Soon active',
  canceled: 'Canceled',
  unpaid: 'Not paid',
  pendingStatus: 'Pending status'
}